import { Component, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss']
})
export class AddButtonComponent implements OnInit {

  @Output() onClick: Subject<void> = new Subject<void>()
  @Input() tooltipContent: string

  constructor() { }

  ngOnInit(): void {
  }

}
